module.exports = __webpack_public_path__ + "images/artis_logo_2f6865b2d0b9296c1110e8110349761b.png";